import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {licencesActionTypes, LoadLicencesSuccessAction} from '../actions/licences';
import {CommonField} from '../../shared/models/common-field';

export interface LicencesState {
  array: CommonField[];
}

const initialState: LicencesState = {
  array: []
};

export function licencesReducer(state: LicencesState = initialState, action: Action): LicencesState {
  switch (action.type) {
    case licencesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case licencesActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: LicencesState, action: LoadLicencesSuccessAction): LicencesState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: LicencesState): LicencesState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}


export const licencesSelectors = {
  array: (state: LicencesState) => _.get(state, 'array', [])
};
